export enum StatusPillType {
  findings = 'findings',
}